import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useGoogleLogin } from '@react-oauth/google';
import googleLogo from 'assets/icons/google-logo.svg';
import Button from 'components/form/Button';
import TextInput from 'components/form/TextInput';
import PasswordInput from 'components/form/PasswordInput';
import Card from 'components/Layout/Card';
// import HeaderLayout from "components/Layout/HeaderLayout";
import LineTextLabel from 'components/Layout/LineTextLabel';
import { handelRegister, setTempUserData } from 'store/slices';
import { errorMsgForMobile, membershipType } from 'utils/constants';
import SliderLayout from 'pages/Auth/SliderLayout';
import {
  convertString,
  numberOnlyFromInput,
  objectToFormData,
  titleCaseString,
} from 'utils/helpers';
import { omit } from 'lodash';
import CheckBox from 'components/form/CheckBox';
// import "./Register.scss";

const Register = () => {
  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const params = useParams();
  const [loadButton, setLoadButton] = useState(false);
  const { apiError } = useSelector((state) => ({
    apiError: state.global.apiError,
  }));

  const [isGoggleBtnLoad, setIsGoggleBtnLoad] = useState(false);
  const login = useGoogleLogin({
    onSuccess: async (response) => {
      const data = await axios.get(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        {
          headers: {
            Authorization: `Bearer ${response.access_token}`,
          },
        }
      );
      if (data?.status === 200) {
        const { given_name, family_name, email, sub, picture } =
          data?.data || {};
        handelSave({
          profile_photo_path: picture,
          first_name: given_name,
          last_name: family_name,
          email_id: email,
          google_id: sub,
          country_code: 'IN',
        });
      }
      setIsGoggleBtnLoad(false);
    },
  });
  const handelSave = async (values) => {
    setLoadButton(true);
    const findType = membershipType.find((o) => o.type === params.type);
    if (findType) {
      let payload = { ...values, user_type: findType.id };
      let forData = objectToFormData(omit(payload, ['mobile_no_length']));
      const response = await dispatch(handelRegister(forData));
      if (response?.status === 200) {
        // nevigate(commonRoute.verifyEmail, {
        //   replace: true,
        //   state: {
        //     email: values.email,
        //   },
        // });
        // full load: the logged-in routes (where this page lives) only mount on app start
        window.location.assign(`/${findType?.type}/membership-confirmed`);
        // findType?.id === "3"
        //   ? nevigate(
        //       `/${findType?.type}/register/${params.userId}/institution-details`
        //     )
        //   : nevigate(
        //       `/${findType?.type}/register/${response?.data?.id}/personal-details`
        //     );
      }
      if (response?.status === 100) {
        dispatch(setTempUserData(response?.data));
        nevigate(`/${params.type}/new-password`);
      }
    }
    setLoadButton(false);
  };
  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .required('First name is required.')
      .matches(/^\S*$/, 'Whitespace is not allowed.'),
    // last_name: Yup.string()
    //   .required('Last name is required.')
    //   .matches(/^\S*$/, 'Whitespace is not allowed.'),
    email_id: Yup.string()
      .required('Email is required.')
      .matches(/^\S*$/, 'Whitespace is not allowed.')
      .email('Email must be a valid email')
      .test(
        'not-mailinator',
        'Sign-up using Mailinator emails is not allowed. Please provide a valid email address.',
        (value) => value && !value.endsWith('@mailinator.com')
      ),
    // phone_number: Yup.string()
    //   .required("Phone number is required.")
    //   .min(4, "Phone number must be minimum 4 digit.")
    //   .max(13, "Phone number must be maximum 13 digit."),
    phone_number: Yup.lazy((_, obj) => {
      const { country_code, mobile_no_length } = obj?.parent || {};
      // if (country_code) {
      //   return Yup.string()
      //     .required("Phone number is required.")
      //     .min(mobile_no_length, errorMsgForMobile(mobile_no_length)?.min)
      //     .max(mobile_no_length, errorMsgForMobile(mobile_no_length)?.max);
      // } else {
      //   return Yup.string();
      // }

      //Array check
      // if (country_code && mobile_no_length) {
      //   const validLengths = Array.isArray(mobile_no_length) ? mobile_no_length : [mobile_no_length];
      //   return Yup.string()
      //     .required("Phone number is required.")
      //     .test(
      //       "valid-length",
      //       `Phone number must be ${validLengths.join(" or ")} digits.`,
      //       (value) => value && validLengths.includes(value.length)
      //     );
      // } else {
      //   return Yup.string();
      // }

      if (country_code === 'IN' && mobile_no_length) {
        const validLengths = Array.isArray(mobile_no_length)
          ? mobile_no_length
          : [mobile_no_length];
        return Yup.string()
          .required('Phone number is required.')
          .test(
            'valid-length',
            `Phone number must be ${validLengths.join(' or ')} digits.`,
            (value) => value && validLengths.includes(value.length)
          );
      } else {
        return Yup.string()
          .required('Phone number is required.')
          .min(8, 'Phone number must be at least 8 digits.')
          .max(15, 'Phone number must be at most 15 digits.');
      }
    }),
    password: Yup.string()
      .required('Password is required.')
      .min(6, 'Password must be at least 6 characters.')
      .max(16, 'Password must be at most 16 characters.')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,16}$/,
        'Password was not strong.'
      ),
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,16}$/,
    //   'Password was not strong.'
    // ),
    confirm_password: Yup.string()
      .required('Confirm password is required.')
      .oneOf([Yup.ref('password'), null], 'Password not matched.'),
    terms_conditions: Yup.boolean().oneOf(
      [true],
      'You must accept the terms and conditions.'
    ),
  });
  const initialValues = {
    first_name: '',
    last_name: '',
    email_id: '',
    phone_number: '',
    country_code: 'IN',
    mobile_no_length: 10,
    password: '',
    confirm_password: '',
    terms_conditions: false,
  };
  return (
    <SliderLayout>
      <Card className="m-auto card-padding h-100 overflow-auto iferp-scroll">
        <div className="m-auto text-center">
          <div className="text-center text-24-500 color-raisin-black cmb-20 font-poppins">
            Welcome!
          </div>
          <div className="text-center text-16-400 color-raisin-black mb-5">
            Stay updated on your professional world
          </div>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handelSave}
        >
          {(props) => {
            const {
              values,
              errors,
              handleChange,
              setFieldValue,
              handleSubmit,
            } = props;

            return (
              <form
                onSubmit={handleSubmit}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSubmit(values);
                  }
                }}
              >
                <div className="mb-4 row">
                  <div className="col-md-6 col-sm-12">
                    <TextInput
                      label="First Name"
                      id="first_name"
                      placeholder="First Name*"
                      value={values.first_name}
                      onChange={(e) => {
                        setFieldValue(
                          'first_name',
                          titleCaseString(e.target.value)
                        );
                      }}
                      error={errors.first_name}
                      isRequired
                    />
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <TextInput
                      label="Last Name"
                      id="last_name"
                      placeholder="Last Name"
                      value={values.last_name}
                      onChange={(e) => {
                        setFieldValue(
                          'last_name',
                          titleCaseString(e.target.value)
                        );
                      }}
                      error={errors.last_name}
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <TextInput
                    label="Email Id"
                    isRequired
                    id="email_id"
                    placeholder="Email ID*"
                    value={values.email_id}
                    error={
                      apiError?.message?.includes('Email ID') ? (
                        <p className="text-danger">
                          Email Id already exists!{' '}
                          <span
                            className="text-14-500 color-new-car underline ps-1 pointer"
                            onClick={() => {
                              nevigate('/member/login');
                            }}
                          >
                            <u>Login Now</u>
                          </span>
                        </p>
                      ) : (
                        errors.email_id
                      )
                    }
                    // error={errors.email_id}
                    onChange={(e) => {
                      handleChange(convertString(1, e));
                    }}
                  />
                </div>
                <div className="mb-4">
                  <TextInput
                    label="Phone Number"
                    isRequired
                    isPhoneNumber
                    type="number"
                    id="phone_number"
                    placeholder="Phone Number*"
                    value={values.phone_number}
                    // error={errors.phone_number}
                    error={
                      apiError?.message?.includes('phone number') ? (
                        <p className="text-danger">
                          Phone number already exists!{' '}
                          <span
                            className="text-14-500 color-new-car underline ps-1 pointer"
                            onClick={() => {
                              nevigate('/member/login');
                            }}
                          >
                            <u>Login Now</u>
                          </span>
                        </p>
                      ) : (
                        errors.phone_number
                      )
                    }
                    phoneNumberData={{
                      id: 'country_code',
                      value: values.country_code,
                    }}
                    onChange={(e) => {
                      if (e.target.id === 'phone_number') {
                        handleChange(numberOnlyFromInput(e));
                      } else {
                        handleChange(e);
                        handleChange({
                          target: { id: 'phone_number', value: '' },
                        });
                        setFieldValue('mobile_no_length', e.target.length);
                      }
                    }}
                  />
                </div>
                <div className="mb-4">
                  <PasswordInput
                    label="Create Password*"
                    id="password"
                    placeholder="Password*"
                    value={values.password}
                    onChange={handleChange}
                    error={errors.password}
                    isShowSuggetion
                  />
                </div>
                <div className="mb-2">
                  <PasswordInput
                    label="Confirm Password*"
                    id="confirm_password"
                    placeholder="Confirm Password*"
                    value={values.confirm_password}
                    onChange={handleChange}
                    error={errors.confirm_password}
                  />
                </div>
                <div className=" mb-2">
                  <div className="form-check">
                    <CheckBox
                      type="PRIMARY-ACTIVE"
                      onClick={(e) => {
                        e.preventDefault();
                        setFieldValue(
                          'terms_conditions',
                          !values.terms_conditions
                        );
                      }}
                      isChecked={values.terms_conditions}
                      className="form-check-input"
                    />
                    <label
                      className="text-10-400 color-raisin-black"
                      htmlFor="terms_conditions"
                    >
                      I agree to the{' '}
                      <span
                        className="color-7cff pointer"
                        onClick={() => {
                          nevigate('#');
                        }}
                      >
                        Terms and Conditions
                      </span>{' '}
                      and{' '}
                      <span
                        className="color-7cff pointer"
                        onClick={() => {
                          nevigate('#');
                        }}
                      >
                        Privacy Policy
                      </span>
                    </label>
                  </div>

                  {errors.terms_conditions && (
                    <span className="text-10-400 d-flex align-items-cemter gap-2">
                      <span style={{ color: 'red' }}>
                        {errors.terms_conditions}
                      </span>
                    </span>
                  )}
                </div>

                <div className="mb-3 pt-3">
                  <Button
                    text="Register"
                    btnStyle="primary-dark"
                    isRounded
                    onClick={handleSubmit}
                    disabled={loadButton}
                    btnLoading={loadButton}
                  />
                </div>

                <div className="text-center mb-3">
                  <span className="text-14-400">Already on IFERP? </span>
                  <span
                    className="text-14-500 color-new-car underline ps-2 pointer"
                    onClick={() => {
                      nevigate('/member/login');
                    }}
                  >
                    <u>Login</u>
                  </span>
                </div>
                {params?.type !== 'admin' && (
                  <>
                    <LineTextLabel text="OR" />
                    <div className="mt-4 mb-4">
                      <Button
                        isRounded
                        text="Continue with Google"
                        btnStyle="light-outline"
                        onClick={() => {
                          setIsGoggleBtnLoad(true);
                          login();
                        }}
                        btnLoading={isGoggleBtnLoad}
                        icon={
                          <img src={googleLogo} alt="google" className="pe-2" />
                        }
                      />
                    </div>
                  </>
                )}
              </form>
            );
          }}
        </Formik>
      </Card>
    </SliderLayout>
  );
};
export default Register;
